export default function limitStringLength(string, maxLen = 50) {
  if (string.length < maxLen) return string;

  return string.substr(0, maxLen) + "...";
}
